import React from 'react';

export default function WalletModal({ onClose, points, history }) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 shadow-lg max-h-[80vh] overflow-auto">
        <h2 className="text-xl font-bold mb-4">Ví điểm thưởng</h2>
        <p className="mb-4 text-lg">
          Tổng điểm hiện tại: <span className="font-semibold">{points ?? 0} ⭐</span>
        </p>
        <h3 className="font-semibold mb-2">Lịch sử điểm</h3>
        {history && history.length > 0 ? (
          <ul className="list-disc list-inside max-h-48 overflow-y-auto border rounded p-2">
            {history.map((item, idx) => (
              <li key={idx}>
                <span className="font-semibold">{item.date}:</span> {item.description} — <span className="text-yellow-500">{item.points} ⭐</span>
              </li>
            ))}
          </ul>
        ) : (
          <p>Chưa có lịch sử điểm.</p>
        )}
        <button
          onClick={onClose}
          className="mt-6 bg-yellow-400 text-black font-bold px-4 py-2 rounded hover:bg-yellow-500"
        >
          Đóng
        </button>
      </div>
    </div>
  );
}
